import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Drawer from 'flarum/common/utils/Drawer';
export default () => {
  extend(Drawer.prototype, 'show', function () {
    const isMobile = window.zivenCore.isMobile();
    const currentUser = app.session.user;
    if (!isMobile) {
      return;
    }
    const sideBarContainer = $(".App-sidebar-items-container");
    if (sideBarContainer.hasClass("ModifiedSideBar") === false) {
      if (!currentUser) {
        $(".App-sidebar-items-container").addClass("ModifiedSideBar");
        $(".App-sidebar-items-container").prepend("<div class='DrawerHeadIcon'></div>");
      }
    }
    $('.App-sidebar-user-block').on('touchmove', function (e) {
      e.preventDefault();
    });
    $('.drawer-backdrop').on('touchmove', function (e) {
      e.preventDefault();
    });
    $('.App-sidebar-container').animate({
      scrollTop: 0
    }, 0);
  });
  extend(Drawer.prototype, 'hide', function () {
    $('.App-sidebar-user-block').off('touchmove');
    $('.drawer-backdrop').off('touchmove');
  });
};